import styled, { css } from 'styled-components';

import { customScrollMinimal } from '~/components/custom-scroll/CustomScroll.styles';
import { borderRadius } from '~/design-tokens/border-radius/borderRadius';
import { typographyV2 } from '~/design-tokens/typography/Typography.styles';
import { timingFunction } from '~/utils/transitions';

import { NavItem } from './components/nav-item/NavItem';

export const AsideExpandable = styled.aside<{ $isExpanded: boolean }>`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  border-right: 1px solid var(--border-soft);
  height: 100%;
  transition: width 0.3s ${timingFunction.base};
  background-color: var(--background-soft);
  z-index: var(--z-index-sidebar);
  padding: 20px 8px;
  width: ${({ $isExpanded }) => ($isExpanded ? '260px' : '48px')};
`;

export const Header = styled.header`
  ${typographyV2.titleBase}
  padding-left: 8px;
  white-space: nowrap;
`;

export const ToggleButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ActionButtonWrapper = styled.button`
  ${typographyV2.bodySm};
  ${borderRadius.r2};
  display: flex;
  align-items: center;
  border: none;
  background: none;
  cursor: pointer;
  outline: none;
  width: 100%;
  height: auto;
  gap: 8px;
  padding: 6px 8px;
  margin-top: 8px;
  color: var(--text-default);
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    background-color: var(--surface-hover);
  }
`;

export const ToggleButton = styled.button<{ $isExpanded: boolean }>`
  background-color: var(--background-soft);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;

  &:hover,
  &:focus-visible {
    border-color: var(--surface-hover);
    background-color: var(--surface-hover);
  }

  ${({ $isExpanded }) =>
    $isExpanded &&
    css`
      transform: rotate(180deg);
    `};
`;

export const ActionButton = styled.button`
  width: 32px;
  height: 32px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background-color: var(--background-soft);

  &:hover,
  &:focus-visible {
    border-color: var(--surface-hover);
    background-color: var(--surface-hover);
  }
`;

export const Separator = styled.hr`
  height: 1px;
  width: 100%;
  margin-top: 16px;
  background-color: var(--border-soft);
  border: none;
`;

export const Categories = styled.div<{
  $isExpanded: boolean;
  $bottom?: boolean;
}>`
  display: flex;
  flex-direction: column;
  margin-top: ${({ $bottom }) => ($bottom ? 'auto' : '16px')};
  overflow-x: clip;
  overflow-y: auto;
  ${customScrollMinimal};
  gap: 4px;

  ${({ $isExpanded }) =>
    $isExpanded &&
    css`
      ${NavItem.Styled.MainLabel} {
        opacity: 1;
      }
    `}
`;
